import React from "react";
import PageWrapper from "./components/PageWrapper";

import { BrowserRouter as Router, Route, Link } from "react-router-dom";
// Pages
//import Home from "./components/Pages/Home";
import About from "./components/Pages/About";
import Contact from "./components/Pages/Contact";
import Services from "./components/Common/Services";

import Team from "./components/Common/Team";
import Login from "./components/Pages/Login";
import LoginWrapper from "./components/LoginWrapper";
import Signup from "./components/Pages/Signup";
import DashBoard from "./components/Pages/DashBoard";
import DashWrap from "./components/Pages/DashWrap";
import AdminPanel from "./components/Pages/AdminPanel";
import Preloader1 from "./components/Preloader1";

const App = () => {
  return (
    <div>
      <Router>
        <Route
          path="/AdminPanel"
          render={(props) => (
            <DashWrap>
              <AdminPanel />
            </DashWrap>
          )}
        />
        <Route
          path="/dash"
          render={(props) => (
            <DashWrap>
              <DashBoard />
            </DashWrap>
          )}
        />
        <Route
          path="/Signup"
          render={(props) => (
            <LoginWrapper>
              <Signup />
            </LoginWrapper>
          )}
        />
        <Route
          path="/login"
          render={(props) => (
            <LoginWrapper>
              <Login />
            </LoginWrapper>
          )}
        />

        <Route
          exact={true}
          path="/"
          render={(props) => (
            <Preloader1>
              <PageWrapper />
            </Preloader1>
          )}
        />

        <Route
          path="/services"
          render={(props) => (
            <PageWrapper>
              <Services />
            </PageWrapper>
          )}
        />

        <Route
          path="/about"
          render={(props) => (
            <PageWrapper>
              <About />
            </PageWrapper>
          )}
        />

        <Route
          path="/team"
          render={(props) => (
            <PageWrapper>
              <Team />
            </PageWrapper>
          )}
        />

        <Route
          path="/contact"
          render={(props) => (
            <PageWrapper>
              <Contact />
            </PageWrapper>
          )}
        />
      </Router>
    </div>
  );
};

export default App;
